import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const BANK_CESSION = {
  YES: 'yes',
  NO: 'no',
} as const;

export const BANK_CESSION_NAME = 'bank_cession';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioGroupBankCession: FC<Props> = ({
  name = BANK_CESSION_NAME,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{i18n.t('Jest cesja polisy na bank?')}</FormLabel>
          <FormControl>
            <RadioGroup {...field} layout={'horizontal'}>
              <RadioItem
                data-testid={`${name}-radio-group-${BANK_CESSION.YES}`}
                value={BANK_CESSION.YES}
                label={i18n.t('Tak')}
              />
              <RadioItem
                data-testid={`${name}-radio-group-${BANK_CESSION.NO}`}
                value={BANK_CESSION.NO}
                label={i18n.t('Nie')}
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
